import theme from 'stories/utils/theme'
import styled from 'styled-components'
import BookImage from 'assets/university/books.png'
import NotebookImage from 'assets/university/notebook.png'
import JellyImage from 'assets/university/jelly.png'
import BackgroundAsset from 'assets/university/header-background.png'
import { ReactNode } from 'react'

const HeaderContainer = styled.div`
    width: 100%;
    height: 70vh;
    min-height: 800px;
    background-color: ${theme.colors.darkThemeBackgroundGradient};
    display: grid;
    overflow: hidden;
    position: relative;
    @media (max-width: 1050px) {
        min-height: 1000px;
    }
`

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    width: 80%;
    height: 80%;
    border: 1px solid var(--Core-Grayscale-Dividers, #ffffff26);
    background-color: #00000099;
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.4);

    border-radius: ${theme.borderRadius.webappButton};
    backdrop-filter: blur(5px);
    padding: 2.5rem;
    z-index: 2;
    gap: 50px;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @media (max-width: 1050px) {
        gap: 10px;
        h1 {
            text-align: center;
            padding: 1rem;
        }
        height: fit-content;
    }
    @media (max-width: 750px) {
        padding: 20px;
        width: 95%;
        height: 85%;
    }
`

const BackgroundWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;

    img {
        position: absolute;
        object-fit: contain;
    }
`

const BackgroundMain = styled.img`
    top: 0;
    right: 0;
    height: 100%;
`

const BookImg = styled.img`
    top: 0%;
    right: 0%;
    height: fit-content;
    z-index: 1;

    @media (max-width: 768px) {
        right: 2%;
        height: 20%;
    }
`

const NotebookImg = styled.img`
    bottom: 5%;
    left: 5%;
    height: fit-content;
    z-index: 1;

    @media (max-width: 768px) {
        left: 5%;
        height: 15%;
        bottom: 5%;
    }
`

const JellyImg = styled.img`
    bottom: 0px;
    right: 0px;
    height: fit-content;
    z-index: 3;
    scale: 1.25;
    @media (max-width: 750px) {
        display: none;
    }
`

interface Props {
    children: ReactNode
}

const UniversityFeatureHeader = ({ children }: Props) => {
    return (
        <HeaderContainer>
            <BackgroundWrapper>
                <BackgroundMain src={BackgroundAsset.src} alt="Background" />
                <BookImg src={BookImage.src} alt="Books" width={BookImage.width} height={BookImage.height} />
                <NotebookImg
                    src={NotebookImage.src}
                    alt="Notebook"
                    width={NotebookImage.width}
                    height={NotebookImage.height}
                />
                <JellyImg src={JellyImage.src} alt="Jelly" width={JellyImage.width} height={JellyImage.height} />
            </BackgroundWrapper>

            <ContentWrapper>{children}</ContentWrapper>
        </HeaderContainer>
    )
}

export default UniversityFeatureHeader
